
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Emotion } from "../interfaces/Interfaces";
import { mapGetters, mapActions, mapMutations } from "vuex";
import DisplayAnalysisGraph from "./DisplayAnalysisGraph.vue";
import analysisSettings from "../store/modules/analysisSettings";
import { Filter } from "../interfaces/Interfaces";

@Component({
  components: {
    DisplayAnalysisGraph,
  },
  computed: {
    ...mapGetters("controller", {
      isMultiselection: "isMultiselection",
    }),
    ...mapGetters("stimulus", {
      filters: "getFilters",
      showOnlyFilteredData: "getShowOnlyFilteredData",
    }),
  },
  methods: {
    ...mapMutations("analysisSettings", {
      toggleShowScenes: "toggleShowScenes",
    }),
    ...mapMutations("analysisSettings", {
      toggleRemoveNoise: "toggleRemoveNoise",
    }),
    ...mapMutations("analysisSettings", {
      setFilters: "setFilters",
    }),
  },
})
export default class DisplayAnalysis extends Vue {
  public graphTimestamp?: number | null = null;
  private isVideoPlaying: boolean = false;
  private videoTimestamp?: number | null = null;
  private showYAxisValue: boolean = true;
  private showDisplayScenes: boolean = true;
  private showSplitByGender: boolean = true;
  private showSplitByAge: boolean = true;
  private showSplitByFilter: boolean = true;
  private filtersState: boolean[] = [false];
  private currentFilterIndex: number = -1;
  private showExportVideo: boolean = true;

  private get yAxisMaxValue(): number {
    return this.$store.state.analysisSettings.yAxisMaxValue;
  }
  private set yAxisMaxValue(value: number) {
    this.$store.commit("analysisSettings/setYAxisMaxValue", value);
  }

  private get showScenes(): boolean {
    return this.$store.state.analysisSettings.showScenes;
  }
  private set showScenes(value: boolean) {
    this.$store.commit("analysisSettings/toggleShowScenes", value);
  }

  private get removeNoise(): boolean {
    return this.$store.state.analysisSettings.removeNoise;
  }
  private set removeNoise(value: boolean) {
    this.$store.commit("analysisSettings/toggleRemoveNoise", value);
  }

  private get genderSplit(): boolean {
    return this.$store.state.analysisSettings.genderSplit;
  }
  private set genderSplit(value: boolean) {
    if (this.showOnlyFilteredData) {
      return;
    }
    if (value) {
      this.filterSplit(-1);
    }
    this.$store.commit("analysisSettings/toggleGenderSplit", value);
  }

  private get ageGroupSplit(): any {
    return this.$store.state.analysisSettings.ageGroupSplit;
  }
  private set ageGroupSplit(value: any) {
    if (this.showOnlyFilteredData) {
      return;
    }
    if (value) {
      this.filterSplit(-1);
    }
    this.$store.commit("analysisSettings/toggleAgeGroupSplit", value);
  }

	  filterSplit(index: number) {
	    const hasFilters = Array.isArray(this.filters) && this.filters.length > 0;
	    if (
	      index !== -1 &&
	      (!hasFilters || index < 0 || index >= this.filters.length)
	    ) {
	      return;
	    }
	
	    let nextIndex = index;
	    if (index === -1) {
	      nextIndex = -1;
	    } else if (this.currentFilterIndex === index) {
	      nextIndex = -1;
	    }
	
	    if (this.mustApplyFirstFilter && nextIndex === -1) {
	      nextIndex = 0;
	    }
	
	    this.currentFilterIndex = nextIndex;

    for (let i = 0; i < this.filters.length; i++) {
      this.$set(this.filtersState, i, this.currentFilterIndex === i);
    }

    this.$store.commit(
      "analysisSettings/toggleFilterSplit",
      this.currentFilterIndex
    );
  }

	  private onFilterToggle(index: number, nextValue: any): void {
	    if (nextValue === false) {
	      this.filterSplit(-1);
	      return;
	    }
	    this.filterSplit(index);
	  }

  // filterSplit(value: any) {
  //   console.log("Filter split changed to index: ", value);
  //   if (value === -1) {
  //     this.currentFilterIndex = -1;
  //     for (var i = 0; i < this.filters.length; i++) {
  //       this.filtersState[i] = false;
  //     }
  //   } else {
  //     if (this.filtersState.includes(true)) {
  //       this.currentFilterIndex = value;
  //       for (var i = 0; i < this.filters.length; i++) {
  //         this.filtersState[i] = i === value;
  //       }
  //     } else {
  //       this.currentFilterIndex = -1;
  //     }
  //   }
  //   this.$store.commit(
  //     "analysisSettings/toggleFilterSplit",
  //     this.currentFilterIndex
  //   );
  // }

  private isMultiselection!: boolean;
  private filters!: Filter[];
  private showOnlyFilteredData!: boolean;

  @Prop() private emotions!: Emotion[];
  @Prop() private emotionsWithFilters!: Emotion[];
  @Prop() private selectedEmotion!: string;
  @Prop() private selectedMode!: string;
  @Prop() private multipleEmotions!: string[];
  @Prop() private emotionSettings!: string[][];
  @Prop() private isClientMode!: boolean;
  @Prop() private videoUrl!: string;
  @Prop() private defaultYMaxValue!: number;

  private get baseEmotions(): Emotion[] {
    const hasFiltered =
      Array.isArray(this.emotionsWithFilters) && this.emotionsWithFilters.length > 0;
    if (this.showOnlyFilteredData && hasFiltered) {
      return this.emotionsWithFilters;
    }
    return this.emotions;
  }

  private get emotion() {
    return this.baseEmotions.find(
      (e: Emotion): boolean => e.type === this.selectedEmotion
    );
  }

	  private get mustApplyFirstFilter(): boolean {
	    return (
	      !!this.showOnlyFilteredData &&
	      Array.isArray(this.filters) &&
	      this.filters.length > 0
	    );
	  }
	
	  private enforceFirstFilterIfNeeded(): void {
	    if (!this.mustApplyFirstFilter) return;
	    if (this.currentFilterIndex === -1) {
	      this.filterSplit(0);
	    }
	  }

  mounted(): any {
    const video: any = document.getElementById("adVideo");
    if (video) {
      video.onplaying = (event: any): void => {
        this.isVideoPlaying = !this.isVideoPlaying;
      };
      video.onpause = (event: any): void => {
        this.isVideoPlaying = !this.isVideoPlaying;
      };
      video.ontimeupdate = (event: any): void => {
        this.videoTimestamp = event.target.currentTime;
      };
    }

    this.yAxisMaxValue = this.defaultYMaxValue;
    for (var i = 0; i < this.filters.length - 1; i++) {
      this.filtersState.push(false);
    }
    if (Array.isArray(this.filters) && this.filters.length > 0) {
      this.filterSplit(0);
    } else {
      this.filterSplit(-1);
    }

    this.$nextTick(() => {
      if (this.isClientMode) {
        this.showYAxisValue =
          this.emotionSettings[0].indexOf("ymax") > -1 ? true : false;
        this.showDisplayScenes =
          this.emotionSettings[0].indexOf("scenes") > -1 ? true : false;
        this.showSplitByAge =
          this.emotionSettings[0].indexOf("age") > -1 ? true : false;
        this.showSplitByGender =
          this.emotionSettings[0].indexOf("gender") > -1 ? true : false;
        this.showExportVideo =
          this.emotionSettings[0].indexOf("export") > -1 ? true : false;
      }

      this.showSplitByFilter = this.emotionSettings[1].length > 0;
    });
  }

  @Watch("filters")
  private handleFiltersLoaded(newFilters: Filter[]): void {
    const targetLength = Array.isArray(newFilters) ? newFilters.length : 0;
    for (let i = this.filtersState.length; i < targetLength; i++) {
      this.filtersState.push(false);
    }

    if (
      this.currentFilterIndex !== -1 &&
      this.currentFilterIndex >= targetLength
    ) {
      this.filterSplit(-1);
    }

    this.enforceFirstFilterIfNeeded();
    if (this.currentFilterIndex === -1 && targetLength > 0) {
      this.filterSplit(0);
    }
  }

  @Watch("showOnlyFilteredData")
  private handleShowOnlyFilteredDataChanged(): void {
    this.enforceFirstFilterIfNeeded();
  }

  @Watch("graphTimestamp") public setGraphTimestamp(): void {
    const video: any = document.getElementById("adVideo");
    if (this.graphTimestamp) video.currentTime = this.graphTimestamp / 1000;
  }

  @Watch("isMultiselection") private handleIsMultiselection(): void {
    this.currentFilterIndex = -1;
    for (let i = 0; i < this.filtersState.length; i++) {
      this.$set(this.filtersState, i, false);
    }
    this.$store.commit("analysisSettings/disableDataSplits");
  }

  destroyed() {
    this.$store.commit("analysisSettings/toggleShowScenes", false);
  }

  isFilterActive(name: string) {
    if (!this.showSplitByFilter) {
      return false;
    }

    try {
      return this.emotionSettings[1].indexOf(name) > -1;
    } catch (err) {
      return false;
    }
  }

  private isFilterVisible(name: string, index: number): boolean {
    if (this.showOnlyFilteredData && index === 0) return true;
    return this.isFilterActive(name);
  }
}
